import { DisplayValue } from '@adaptiva/core/common';
import { checkBit, setBit } from '@adaptiva/core/math';
import { UiService } from '@adaptiva/core/ui';
import { provideBaseWidget } from '@adaptiva/core/widgets';
import { BaseEditorError, EEditorErrorType, IBaseEditorError } from '@adaptiva/data-service';
import { CheckboxGroupComponent } from '@adaptiva/widgets/checkbox-group';
import { ChangeDetectionStrategy, Component, Signal, WritableSignal, inject, signal, viewChild } from '@angular/core';
import { EDaysOfWeek } from '../../enums';
import { BaseScheduleTypeComponent } from '../base-schedule-type.component';

@Component({
	standalone: false,
	selector: 'app-recurring-by-day',
	templateUrl: './recurring-by-day.component.html',
	providers: [provideBaseWidget(() => RecurringByDayComponent)],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecurringByDayComponent extends BaseScheduleTypeComponent {

	protected readonly daysOfWeekCheckboxes: Signal<CheckboxGroupComponent> = viewChild('DaysOfWeekCheckboxes');

	protected readonly dayOfWeekOptions: DisplayValue<EDaysOfWeek>[] = [
		new DisplayValue<EDaysOfWeek>('Sunday', EDaysOfWeek.SUNDAY),
		new DisplayValue<EDaysOfWeek>('Monday', EDaysOfWeek.MONDAY),
		new DisplayValue<EDaysOfWeek>('Tuesday', EDaysOfWeek.TUESDAY),
		new DisplayValue<EDaysOfWeek>('Wednesday', EDaysOfWeek.WEDNESDAY),
		new DisplayValue<EDaysOfWeek>('Thursday', EDaysOfWeek.THURSDAY),
		new DisplayValue<EDaysOfWeek>('Friday', EDaysOfWeek.FRIDAY),
		new DisplayValue<EDaysOfWeek>('Saturday', EDaysOfWeek.SATURDAY),
	];

	protected readonly selections: WritableSignal<EDaysOfWeek[]> = signal([]);

	protected readonly ui: UiService = inject(UiService);

	public validate(): IBaseEditorError[] {
		const _errors: IBaseEditorError[] = [];

		if (!this.schedule.daysOfWeek) {
			_errors.push(
				new BaseEditorError(
					EEditorErrorType.Error,
					this.guid,
					['DaysOfWeekCheckboxes', 'Must select at least one day']
				));
		}

		return _errors;
	}

	public commitModelToView(): void {
		if (this.schedule.daysOfWeek) {
			const _selections: EDaysOfWeek[] = [];

			for (let i: EDaysOfWeek = EDaysOfWeek.SUNDAY; i <= EDaysOfWeek.SATURDAY; i++) {
				if (checkBit(this.schedule.daysOfWeek, i))
					_selections.push(i);
			}

			this.selections.set(_selections);
		}
	}

	protected updateSelections(_selections: EDaysOfWeek[]): void {
		const _daysAsByte: byte = _selections.reduce((_byte: byte, _day: EDaysOfWeek) => {
			return setBit(_byte, _day, true);
		}, 0);

		this.outputChanges([{
			propertyName: 'daysOfWeek',
			value: _daysAsByte
		}]);
	}

}
